import projection from '../generated/pw2201f1.json'; import { AcceptanceManifest } from '../types';
export const pw2201f1AcceptanceManifest = projection as AcceptanceManifest;
